import React from "react";
import rapidcheckout from "../assets/projectAssets/rapidcheckout.gif";
import "../styles/project.css";

const Rcheckout = () => {
  return (
    <div className="project-content">
      <h2>Rapid Checkout</h2>
      <a href="https://github.com/DhruvGupta3377/rapidcheckout" target="_blank">
        SourceCode
      </a>
      <img src={rapidcheckout} />
      <h3>Technologies used</h3>
      Javascript, ReactJS, MongoDB, Python, Django
      <h3>Why?</h3>
      <li>
        Developed a solution for optimizing the shopping experience in large
        shopping complexes.
      </li>
      <li>
        Implemented a service that provides the real-time location of items in
        the complex, facilitating efficient navigation for customers.
      </li>
      <li>
        The platform features a self-checkout service to alleviate congestion
        during peak hours.
      </li>
      <h3>What is this?</h3>
      <li>Full Stack Application</li>
      <li>With Authentication</li>
      <li>
        The admin dashboard enables store owners to manage inventory seamlessly
      </li>
      <li>
        Customers can use the built-in scanner on the website for automatically
        identifying and adding products through barcodes.
      </li>
      <h3>What I learned?</h3>
      <li>Authentication using JWT token</li>
      <li>Various NPM packages e.g. scanner </li>
      <li>First time working with MongoDB </li>
      <li>Creating a REST API</li>
    </div>
  );
};

export default Rcheckout;
